import React, { useState } from 'react';
import './AuthModal.css';
import { useUser } from '../contexts/UserContext';

const AuthModal = ({ onClose }) => {
  const [tab, setTab] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const { login, register } = useUser();

  const submitLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);
      onClose();
    } catch (err) {
      if (err.status === 401) setError('...אופס, נראה שהתבלבלת');
      else setError('לא עבד:( נסי שוב) ');
    }
  };

  const submitRegister = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await register(name, email, password);
      onClose();
    } catch (err) {
      if (err.status === 409) setError('את כבר רשומה, איזה יופי! תתחברי');
      else setError(err.message || 'לא עבד :(');
    }
  };

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-dialog" onClick={e => e.stopPropagation()}>
        <div className="auth-tabs">
          <button className={tab==='login'? 'active':''} onClick={() => setTab('login')}>התחברות</button>
          <button className={tab==='register'? 'active':''} onClick={() => setTab('register')}>הרשמה</button>
        </div>
        <div className="auth-body">
          {error && <div className="auth-error">{error}</div>}
          {tab === 'login' ? (
            <form onSubmit={submitLogin} className="auth-form">
              <label>אימייל<input value={email} onChange={e=>setEmail(e.target.value)} type="email" required /></label>
              <label>סיסמה<input value={password} onChange={e=>setPassword(e.target.value)} type="password" required /></label>
              <div className="auth-actions"><button type="submit">מכאן מתחברים</button></div>
            </form>
          ) : (
            <form onSubmit={submitRegister} className="auth-form">
              <label>שם<input value={name} onChange={e=>setName(e.target.value)} required /></label>
              <label>אימייל<input value={email} onChange={e=>setEmail(e.target.value)} type="email" required /></label>
              <label>סיסמה<input value={password} onChange={e=>setPassword(e.target.value)} type="password" required /></label>
              <div className="auth-actions"><button type="submit">מכאן נרשמים</button></div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
